import { VirtualObjectsResponse } from '@spazious/dollhouse-graphql';
import { VirtualFurnitureAttributesAvailabilityStatusEnum } from '@spazious/react-booking-engine';

import { RestApiClient } from '../context.js';

import { mapDecoration } from './mapDecoration.js';

export const getDecorations = async (
  api: RestApiClient,
  spaceId: string,
  pageNumber: number
): Promise<VirtualObjectsResponse> => {
  const result = await api.diagramming.listDiagrammingVirtualObjects({
    filterVirtualMeetingRoom: spaceId,
    filterAvailabilityStatusIn: VirtualFurnitureAttributesAvailabilityStatusEnum.Public,
    pageSize: 100,
    pageNumber,
  });

  return {
    data: result.data.data.map(mapDecoration),
    pagination: {
      hasNext: !!result.data.links?.next,
    },
  };
};
